import {BOM} from './BOM'
import {BomTabsList} from './BomTabsList'
import {BomRematch} from './BomRematch'
import {BomProductListing} from './BomProductListing'
import BomExactMatchTable from "./BomListing/BomTabsData/BomExactMatchTable";
import BomMultipleMatchTable from "./BomListing/BomTabsData/BomMultipleMatchTable";
import BomNoMatchTable from "./BomListing/BomTabsData/BomNoMatchTable";
import React from "react";
import store from "../../storeWire";

class Common {
    //MainPage
    static chain = {
        CreateBom: {param_value: 'CreateBom', element: BOM},
        BomTabsList: {param_value: 'BomTabsList', element: BomTabsList},
        BomRematch: {param_value: 'BomRematch', element: BomRematch},
        BomProductListing: {param_value: 'BomProductListing', element: BomProductListing},
        BomDetailById: {param_value: 'BomDetailById', element: BomTabsList},
    };
    static param_key = '__c';
    static param_key_bomId = 'bomId';
    static redux_key = 'BOM__Component__Loader';
    static default_component = Common.chain.CreateBom;
    //BomDetailPage
    static chain_BomTabList = {
        BomExactMatchTable: {
            name: 'Exact Match',
            api_fetch_type: 'Exact',
            param_value: 'BomExactMatchTable',
            store: () => {
                return Common.getBomDetailValueFromStore('Exact')
            },
            icon: <i className="fa fa-check-circle me-1 text-darkgreen font-16"/>,
            element: BomExactMatchTable
        },
        BomMultipleMatchTable: {
            name: 'Multiple Match',
            api_fetch_type: 'Multiple',
            param_value: 'BomMultipleMatchTable',
            store: () => {
                return Common.getBomDetailValueFromStore('Multiple')
            },
            icon: <i className="fa fa-warning me-1 text-yellow font-16"/>,
            element: BomMultipleMatchTable
        },
        BomNoMatchTable: {
            name: 'No Match',
            api_fetch_type: 'NoMatch',
            param_value: 'BomNoMatchTable',
            store: () => {
                return Common.getBomDetailValueFromStore('NoMatch')
            },
            icon: <i className="fa fa-warning me-1 text-red font-16"/>,
            element: BomNoMatchTable
        }
    };

    static getBomDetailValueFromStore(api_fetch_type) {
        let s = store.getState();
        if (s.entities.model_BOM.bomDetailByBomIDWithType !== undefined &&
            s.entities.model_BOM.bomDetailByBomIDWithType[api_fetch_type] !== undefined
        ) {
            return s.entities.model_BOM.bomDetailByBomIDWithType[api_fetch_type];
        }
        return {
            count: 0
        };
    }

    static loadMore(top, props) {
        let t = JSON.parse(JSON.stringify(top));
        if (t[props.current_chain.api_fetch_type] !== undefined &&
            t[props.current_chain.api_fetch_type].top !== undefined
        ) {
            t[props.current_chain.api_fetch_type].top = t[props.current_chain.api_fetch_type].top + 10;
        } else {
            t[props.current_chain.api_fetch_type] = {};
            t[props.current_chain.api_fetch_type].top = 30;
        }
        return t;
    }

    static getBOMAlertClass(message) {
        if (message !== undefined && message !== null) {
            return (message.includes('exceeded 1000 lines') ||
                message.includes('altered to meet the file')) ? 'warning' : 'danger';
        } else {
            return 'danger';
        }
    }

    static param_key_BomTabList = '__c_BomTabList';
    static param_key_bomId_BomTabList = 'bomId';
    static redux_key_BomTabList = 'BomTabList__Component__Loader';
    static default_component_BomTabList = Common.chain_BomTabList.BomExactMatchTable;
}

export default Common;